import React from 'react';
import Header from '../components/Header';
import AfroNation2027 from '../components/AfroNation2027';
import VoyageEnCours from '../components/VoyageEnCours';
import Commandments from '../components/Commandments';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Header />
      <AfroNation2027 />
      <VoyageEnCours />
      <Commandments />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
